import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Payments } from '@share/common-types';

export interface CreditLineInvoiceDetail {
  creditLineInvoiceDetailId: number;
  bookingId: number;
  paid: boolean;
  paidDate: string;
  amount: number;
}

export interface CreditLineInvoice {
  creditLineInvoiceId: number;
  created: string;
  amount: string;
  urlPdf: string;
  dueDate: string;
  comments: string;
  paymentStatus: string;
  paidDate: string;
  accountName: string;
  creditLineInvoiceDetails: CreditLineInvoiceDetail[];
}

interface BankName {
  bankName: string;
  lastFourDigits: string;
  bankType: string;
  bankId: number;
}
export interface CreditLineState {
  creditLine: any;
  dueAmount: number;
  selectedCreditLine: CreditLineInvoice[];
  bankName: BankName | null;
  payments: Payments[]
  totalPending: number;
  dueDate: string;
}

const initialState: CreditLineState = {
  creditLine: null,
  dueAmount: 0,
  selectedCreditLine: [],
  bankName: null,
  payments: [],
  totalPending: 0,
  dueDate: '',
  
};

const creditLineSlice = createSlice({
  name: 'creditLine',
  initialState,
  reducers: {
    setCreditLineData: (state: CreditLineState, { payload }: PayloadAction<any>) => {
      state.creditLine = payload;
    },
    setDueAmount: (state: CreditLineState, { payload }: PayloadAction<number>) => {
      state.dueAmount = payload;
    },
    setSelectedCreditLineData: (state: CreditLineState, { payload }: PayloadAction<CreditLineInvoice[]>) => {
      state.selectedCreditLine = [...state.selectedCreditLine, ...payload];
    },
    removeSelectedCreditLineData: (state: CreditLineState, { payload }: PayloadAction<number>) => {
      state.selectedCreditLine = state.selectedCreditLine.filter(
        (item) => item.creditLineInvoiceId !== payload
      );
    },
    addNewBankName: (state: CreditLineState, { payload }: PayloadAction<BankName>) => {
      state.bankName = payload;
    },
    savePayment: (state: CreditLineState, { payload }: PayloadAction<Payments[]>) => {
      state.payments = payload;
    },
    setCreditLineSummary: (state: CreditLineState, { payload }: PayloadAction<{ totalPending: number; dueDate: string }>) => {
      state.totalPending = payload.totalPending;
      state.dueDate = payload.dueDate;
    },
  },
});

export const { setCreditLineData, setDueAmount, setSelectedCreditLineData, removeSelectedCreditLineData, addNewBankName, savePayment , setCreditLineSummary} = creditLineSlice.actions;

export const creditLineReducer = creditLineSlice.reducer;